var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilestone24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke secondary-fill",
    d: "m13.66 3.69 6.65 6.65c.92.92.92 2.4 0 3.32l-6.65 6.65c-.92.92-2.4.92-3.32 0l-6.65-6.65a2.35 2.35 0 0 1 0-3.32l6.65-6.65c.92-.92 2.4-.92 3.32 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestone24);
export default __webpack_public_path__ + "static/media/milestone_24.ac54dfadfbedc613ec0cb39b79a88707.svg";
export { ForwardRef as ReactComponent };